import { render, staticRenderFns } from "./salesReturnOrderTemplate.vue?vue&type=template&id=cfc4ac38&scoped=true"
import script from "./salesReturnOrderTemplate.vue?vue&type=script&lang=js"
export * from "./salesReturnOrderTemplate.vue?vue&type=script&lang=js"
import style0 from "./salesReturnOrderTemplate.vue?vue&type=style&index=0&id=cfc4ac38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc4ac38",
  null
  
)

export default component.exports